<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useThemeStore } from './stores/theme'

const themeStore = useThemeStore()

// Initialize theme on mount
onMounted(() => {
  themeStore.initTheme()
})

// Watch for theme changes and apply to html element
watch(
  () => themeStore.isDark,
  (isDark) => {
    if (isDark) {
      document.documentElement.classList.add('dark')
      document.body.style.backgroundColor = '#191919'
      document.body.style.color = 'rgba(255, 255, 255, 0.81)'
    } else {
      document.documentElement.classList.remove('dark')
      document.body.style.backgroundColor = '#FFFFFF'
      document.body.style.color = '#37352F'
    }
  },
  { immediate: true }
)
</script>

<template>
  <router-view />
</template>
